var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var BlockIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 52,
    glyphOffsetX: -3.5
  }), React.createElement("path", {
    d: "M17.3044 42.6957H8.95654V51.0435H17.3044V42.6957Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M17.3044 21.8262H8.95654V30.174H17.3044V21.8262Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M17.3044 0.956543H8.95654V9.30437H17.3044V0.956543Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M59.0435 0.956543H50.6957V9.30437H59.0435V0.956543Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M38.1739 0.956543H29.8261V9.30437H38.1739V0.956543Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M38.1739 21.8262H29.8261V30.174H38.1739V21.8262Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M38.1739 42.6957H29.8261V51.0435H38.1739V42.6957Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M59.0435 42.6957H50.6957V51.0435H59.0435V42.6957Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M59.0435 21.8262H50.6957V30.174H59.0435V21.8262Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M21.4783 17.6522V34.3478H4.78262V17.6522H21.4783ZM25.6522 13.4783H0.608704V38.5218H25.6522V13.4783Z",
    fill: "black"
  }));
};
export var BlockIconGlyph = function (props) {
  return React.createElement(BlockIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};